export const SERVER_URL = import.meta.env.VITE_API_URL;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SITE_DOMAIN = import.meta.env.VITE_SITE_DOMAIN;
export const VERSION = import.meta.env.VITE_VERSION;
export const MONTHLY = import.meta.env.VITE_MONTHLY;
export const SUBSTITUTION_DOMAIN = import.meta.env.VITE_SUBSTITUTION_DOMAIN;
export const STRAPI_API_HOST = import.meta.env.VITE_STRAPI_API_HOST;
export const STRAPI_V4_API_HOST = import.meta.env.VITE_STRAPI_V4_API_HOST;
